export default function LegalNotice() {

    return (
        <div style={{height:'100vh', minHeight:'100vh'}}>
            <embed src="shared-assets/regulatory/Legal_notice.pdf" type="application/pdf" width="100%" height="100%"
                   title="Instructions for use"/>
        </div>
    )
}